let mascotReaction = {
  fullName: "Опишите причину, по которой реакция маскота кажется вам неуместной", 
  type: "text"
}

const errorPlaces = {
  "MASCOT": {
    fullName: "Маскот",
    subform: {
      type: "select",
      fullName: "Возникшая проблема",
      variants: {
        "KEY1": {fullName: "Реакция маскота отсутствует", subform: {fullName: "Опишите ваше действие, на которое не отреагировал маскот", type: "text"}},
        "KEY2": {fullName: "При нажатии на маскота ничего не происходит"},
        "KEY3": {fullName: "Я не могу понять реакцию маскота", subform: {fullName: "Опишите реакцию маскота", type: "text"}},
        "KEY4": {
          fullName: "Реакция маскота кажется нелогичной/неуместной", 
          subform: {
            type: "select",
            fullName: "Какое ваше действие привело к возникновению этой реакции?",
            variants: {
              "KEY1": {fullName: "Ответ на вопрос", subform: mascotReaction},
              "KEY2": {fullName: "Нажатие на маскота", subform: mascotReaction},
              "KEY3": {fullName: "Наведение на элемент маскота", subform: mascotReaction},
              "KEY4": {fullName: "Я знаю это действие, но его нет в списке", subform: mascotReaction},
              "KEY5": {fullName: "Я не могу точно назвать это действие", subform: mascotReaction},
            }
          }
        }  
      }
      
    }
  },
  "ANSWER": {
    fullName: "Вариант ответа",
    subform: {
      type: "select",
      fullName: "Возникшая проблема",
      variants: {
        "KEY1": {fullName: "Опечатка", subform: {fullName: "Напишите правильный вариант ответа", type: "text"}},
        "KEY2": {fullName: "Вариант ответа ошибочно является правильным/неправильным", subform: {fullName: "Объяните, почему вы так считаете", type: "text"}},
        "KEY3": {fullName: "Варианты ответа находится в некорректном порядке", subform: {fullName: "Объяните, почему вы так считаете", type: "text"}},
        "KEY4": {fullName: "Иное", subform: {fullName: "Опишите возникшую ошибку", type: "text"}},
      }
    }
  },
  "MESSAGE": {
    fullName: "Текст сообщения",
    subform: {
      type: "select",
      fullName: "Возникшая проблема",
      variants: {
        "KEY1": {fullName: "Опечатка", subform: {fullName: "Напишите правильный вариант сообщения", type: "text"}},
        "KEY2": {fullName: "Сообщение отображается некорректно или отсутствует", subform: {fullName: "Подробно объясните возникшую проблему", type: "text"}},
        "KEY3": {fullName: "Иное", subform: {fullName: "Подробно объясните возникшую проблему", type: "text"}},
      }
    }

  },
  "SCORE": {
      fullName: "Счет",
      subform: {
        type: "select",
        fullName: "Опишите проблему, возникшую со счетом",
        variants: {
          "KEY1": {fullName: "Я не понимаю, как изменился счет"},
          "KEY2": {
            fullName: "Проблема с анимацией изменения счета",
            subform: {
              type: "select",
              fullName: "Возникшая проблема",
              variants: {
                "KEY1": {fullName: "Анимация слишком быстрая"},
                "KEY2": {fullName: "Анимация слишком медленная"},
                "KEY3": {fullName: "Анимация слишком медленная"},
                "KEY4": {fullName: "Скорость анимации меняется слишком резко"},
                "KEY5": {fullName: "Иное"},
              }
            }
          },
          "KEY3": {fullName: "Счет не отображается"},
          "KEY4": {fullName: "Иное", subform: {fullName: "Опишите проблему, возникшую со счетом", type: "text"}}
        },
      }
  },
  "TITLE": {
      fullName: "Заголовок экрана",
      subform: {
        type: "select",
        fullName: "Возникшая проблема",
        variants: {
            "KEY1": {fullName: "Содержимое ошибочно или пусто"},
            "KEY2": {fullName: "Иное", subform: {fullName: "Опишите проблему, возникшую со заголовком", type: "text"}}
        },
      }
  },
  "QUESTION": {
      fullName: "Формулировка вопроса",
      subform: {
        type: "select",
        fullName: "Возникшая проблема",
        variants: {
          "KEY1": {fullName: "Опечатка", subform: {fullName: "Напишите правильный вариант вопроса", type: "text"}},
          "KEY2": {fullName: "Непонятна формулировка вопроса", subform: {fullName: "Объяните, что вам непонятно в формулировке вопроса", type: "text"}},
          "KEY3": {fullName: "Вопрос некорректно сформулирован", subform: {fullName: "Опишите имеющуюся проблему или предложите правильную (на ваш взгляд) формулировку вопроса", type: "text"}},
          "KEY4": {fullName: "Иное", subform: {fullName: "Опишите возникшую ошибку", type: "text"}},
        }
      }
  },
  "ALL": {
    fullName: "Элемента нет в этом списке",
    subform: {
      type: "text",
      fullName: "Укажите место в игре, где возникла ошибка",
      subform : {
          type: "text",
          fullName: "Опишите возникшую ошибку"
      }
    },
  },
}

const proposalPlace = {
  "ALL": {
    fullName: "По всей игре в целом",
    subform: {
      fullName: "Текст предложения по игре",
      type: "text"
    }
  },
  "MASCOT": {
    fullName: "Маскот",
    subform: {
    fullName: "Текст предложения по маскоту",
    type: "text"
}
  },
  "ANSWER": {
    fullName: "Вариант ответа",
    subform: {
      fullName: "Текст предложения по данному варианту ответа",
      type: "text"
    }
  },
  "MESSAGE": {
    fullName: "Текст сообщения",
    subform: {
    fullName: "Текст предложения по указанному сообщению",
    type: "text"
}
  },
  "SCORE": {
      fullName: "Счет",
      subform: {
      fullName: "Текст предложения по счету игры",
      type: "text"
}
  },
  "TITLE": {
      fullName: "Заголовок экрана",
      subform: {
      fullName: "Текст предложения по заголовку экрана",
      type: "text"
}
  },
  "QUESTION": {
      fullName: "Формулировка вопроса",
      subform: {
      fullName: "Текст предложения по формулировке вопроса",
      type: "text"
    }
  },
}

const qstPlaces = {
  "ALL": {
    fullName: "У меня есть вопрос по всей игре",
    subform: {
      fullName: "Текст вопроса по игре",
      type: "text"
    }
  },
  "MASCOT": {
    fullName: "Маскот",
    subform: {
    fullName: "Текст вопроса по маскоту",
    type: "text"
}
  },
  "ANSWER": {
    fullName: "Вариант ответа",
    subform: {
      fullName: "Текст вопроса по данному варианту ответа",
      type: "text"
    }
  },
  "MESSAGE": {
    fullName: "Текст сообщения",
    subform: {
    fullName: "Текст вопроса по указанному сообщению",
    type: "text"
}
  },
  "SCORE": {
      fullName: "Счет",
      subform: {
      fullName: "Текст вопроса по счету игры",
      type: "text"
}
  },
  "TITLE": {
      fullName: "Заголовок экрана",
      subform: {
      fullName: "Текст вопроса по заголовку экрана",
      type: "text"
}
  },
  "QUESTION": {
      fullName: "Формулировка вопроса",
      subform: {
      fullName: "Текст вопроса по формулировке вопроса",
      type: "text"
    }
  },
}

const CommentType = {
    "PROPOSIAL": {
     fullName: "Предложение по игре",
     subform: {
      fullName: "По какому элементу игры вы хотите оставить свое предложение?",
      type: "select",
      variants: proposalPlace
     }
    },
    "ERROR": {
      fullName: "Сообщение об ошибке",
      subform: {
        type: "select",
        fullName: "С каким элементом игры возникла проблема?",
        variants: errorPlaces
      }
    },
    "QST": {
      fullName: "Вопрос по игре",
      subform: {
        type: "select",
        fullName: "О каком элементе игры вы хотите задать вопрос?",
        variants: qstPlaces
      }
    },
    
    __proto__: {
      byName: function(name) {
        if (name) {
          if (CommentType[name]) return CommentType[name]
          const key = name.replaceAll("-","_").toUpperCase();
          if (CommentType.hasOwnProperty(key)) {
            return CommentType[key]
          }
        }
        return {name: name, fullName: name}
      },
      entries(withTopLevel = false) {
        return Object.entries(CommentType).filter(
          ([, { toplevel }]) => withTopLevel || toplevel !== false
        )
      },
      version(){
          return "1.0";
        }
      } 
}




CommentType.__proto__.byName = CommentType.__proto__.byName.bind(CommentType)
CommentType.__proto__.entries = CommentType.__proto__.entries.bind(CommentType)
CommentType.__proto__.version = CommentType.__proto__.version.bind(CommentType)

for (const key in CommentType) {
  if (CommentType.hasOwnProperty(key)) {
    CommentType[key].name = key.replace(/_/g, "-").toLowerCase()
    Object.freeze(CommentType[key])
  }
}

Object.freeze(CommentType)
Object.freeze(CommentType.__proto__)



export default CommentType;